import { Alert, Button, Pagination } from '@/components/common';
import { SessionList } from '@/components/stream';
import { useStreamManagement } from '@/hooks/useStreamManagement';
import { PaginationMetadata } from '@/models';
import React from 'react';

export const Streams: React.FC = () => {
  const {
    sessions,
    totalCount,
    totalPages,
    currentPage,
    isLoading,
    error,
    labs,
    selectedLabId,
    accessChecks,
    setCurrentPage,
    handleLabFilterChange,
    handleRefresh,
    handleJoin,
    clearError,
  } = useStreamManagement();

  return (
    <div className="container-fluid py-4">
      {/* Header */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h1 className="h3 mb-0">Live Streams</h1>
              <p className="text-muted">
                {totalCount > 0
                  ? `${totalCount} active session${totalCount !== 1 ? 's' : ''}`
                  : 'Browse and join active teaching sessions'}
              </p>
            </div>
            <div className="d-flex align-items-center gap-3">
              {/* Lab filter */}
              <select
                className="form-select form-select-sm"
                value={selectedLabId}
                onChange={(e) => handleLabFilterChange(e.target.value)}
                style={{ minWidth: '180px' }}
              >
                <option value="">All Labs</option>
                {labs.map((lab) => (
                  <option key={lab.id} value={lab.id}>
                    {lab.name}
                  </option>
                ))}
              </select>

              <Button
                variant="secondary"
                outline
                size="sm"
                onClick={handleRefresh}
                icon="fas fa-sync"
              >
                Refresh
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Error */}
      {error && (
        <div className="row mb-3">
          <div className="col-12">
            <Alert variant="danger" dismissible onDismiss={clearError}>
              <i className="fas fa-exclamation-circle me-2" />
              {error}
            </Alert>
          </div>
        </div>
      )}

      {/* Sessions Grid */}
      <SessionList
        sessions={sessions}
        accessChecks={accessChecks}
        isLoading={isLoading}
        onJoin={handleJoin}
      />

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="d-flex justify-content-center mt-4">
          <Pagination
            pagination={
              {
                currentPage,
                pageSize: 10,
                totalPages,
                totalCount,
                hasNext: currentPage < totalPages,
                hasPrevious: currentPage > 1,
              } as PaginationMetadata
            }
            onPageChange={setCurrentPage}
          />
        </div>
      )}
    </div>
  );
};

export default Streams;
